import {find, findID, hasClass, listener} from "../../../../../../../modules/vegas/js/util";
import VGCatalogFilters from "./filters";

document.addEventListener('DOMContentLoaded', onReady)
onTurboRender(onReady);
onFrameRender((event) => {
	if (event.target.id === 'catalog-products') {
		onReady()
	}
})

window.catalogFilter = null;

function getFilterInstance() {
	if (!window.catalogFilter) {
		window.catalogFilter = new VGCatalogFilters();
	}

	let $filtersContainer = findID('catalog-filters');

	if ($filtersContainer) {
		window.catalogFilter.init($filtersContainer);
	}

	return window.catalogFilter;
}

function onReady() {
	let filter = getFilterInstance();
	filter.setApplied();
	filter.select();
}

function listeners () {
	/** Ищут параметр **/
	listener('keyup', '.catalog-filters--item [name=search-filter]', function (el, event) {
		event.preventDefault();

		getFilterInstance().search(el);
	});

	/** Чекают параметр **/
	listener('click', '[data-toggle=filter-check]', function (el, event) {
		event.preventDefault();

		el.addClass('shown')

		if (hasClass(el, 'radio')) {
			getFilterInstance().radio(el);
		} else {
			getFilterInstance().check(el);
		}
	});

	/** Что там вводят в диапазоны **/
	listener('keyup', '.range-input', function (el, event) {
		event.preventDefault();

		getFilterInstance().range(el);
	});

	listener('blur', '.range-input', function (el, event) {
		event.preventDefault();

		getFilterInstance().range(el);
	});

	listener('change', '.range-input', function (el, event) {
		event.preventDefault();

		getFilterInstance().range(el);
	});

	/** Сбрасывают параметр **/
	listener('click', '[data-dismiss="filter-applied"]', function (el, event) {
		event.preventDefault();

		let $set = find('.catalog-filters--item[data-param="' + el.id + '"]');
		if ($set) {
			getFilterInstance().reset($set);
		}
	});

	/** Сбрасывают все параметр **/
	listener('click', '[data-dismiss="filter-applied-all"]', function (el, event) {
		event.preventDefault();

		getFilterInstance().reset();
	});

	/** Тыкнули на кнопку фильтровать **/
	/*listener('click', '#btn-catalog-filter', function (el, event) {
		event.preventDefault();
		filter.submit();
	});*/

}

document.addEventListener("DOMContentLoaded", listeners);
